import React from 'react';
import { notification } from 'antd';
import isEmpty from 'lodash.isempty';

import { NotificationDescription } from './components';
import Translation from '../../UI/Translation';

import { filterNotificationListAdmin } from '../../../helpers/notificationAdmin';

import { NotificationStyle } from './style';

/**
 * Główna funkcja odpowiadająca za otwieranie notyfikacji oraz rozdzielnie filtrowania
 *
 * @param notificationListAdmin
 */
export const openNotificationAdmin = (notificationListAdmin: AppConfig.NotificationAdmin[], userId: string) => {
  const filteredNotificationListAdmin = filterNotificationListAdmin(notificationListAdmin, userId);

  !isEmpty(filteredNotificationListAdmin) &&
    notification.info({
      message: <Translation id={'NOTIFICATION_ADMIN_TITLE'} />,
      description: <NotificationDescription filteredNotificationListAdmin={filteredNotificationListAdmin} />,
      placement: 'topRight',
      duration: 0,
      style: NotificationStyle,
      className: 'cyNotificationAdminNotification',
    });
};
